import React, { useEffect, useState } from 'react'
import APIService from '../../Services/API/APIService'
import { Table, Dimmer, Dropdown, Loader, Label, Image } from 'semantic-ui-react'
import dayjs from "dayjs";
import numeral from "numeral";
import { toast } from "react-toastify";

const PastBoookings = () => {
    const [, setUser] = useState(null)
    const [loading, setLoading] = useState(false);
    const [pastBookings, setPastBookings] = useState([]);
    useEffect(() => {
        const response = APIService.fetchUser()
        setUser(response)
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const response = await APIService.getData('/guest-house/past-bookings')
            setPastBookings(response)
            setLoading(false)
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    const cancelBooking = async (item) => {
   
        try {
            if (window.confirm("Do you wish to cancel this booking?")) {
                setLoading(true);
                await APIService.postData(`/checkout/cancel-booking`, {
                    reference : item,
                });
              
                toast.success("Cancelled Successful");
                fetchData();
            }
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };



let counter = 0
    const bookings = pastBookings?.map((item) => (
        <Table.Row key={item.id}>
            
            <Table.Cell>
               {counter = counter + 1}
            </Table.Cell>
      
            <Table.Cell>
                {item.GuestHousePackage && (
                    <Image
                        src={item.GuestHousePackage?.GuestHouseGalleries[0]?.resizeLocation}
                        style={{ height: 50 }}
                    />
                )}
            </Table.Cell>
            <Table.Cell>
               {item.bookingId}
            </Table.Cell>
            <Table.Cell>
                {dayjs(item.createdAt).format("DD-MMM-YYYY")}
            </Table.Cell>

            <Table.Cell>{dayjs(item.checkin).format("DD-MMM-YYYY")}</Table.Cell>
            <Table.Cell>{dayjs(item.checkout).format("DD-MMM-YYYY")}</Table.Cell>

            <Table.Cell>{item.GuestHousePackage?.name}</Table.Cell>
            <Table.Cell>₦{numeral(item.amount).format("0,0")}</Table.Cell>
            <Table.Cell>{item.nights}</Table.Cell>
            <Table.Cell>₦{numeral(item.total).format("0,0")}</Table.Cell>
            <Table.Cell>
                <Label
                    as="a"

                    basic
                    color={
                        item.status === "APPROVED"
                            ? "teal"
                            : item.status === "BOOKED"
                                ? "violet"
                                : item.status === "COMPLETED"
                                ? "olive"
                                : item.status === "IN_PROGRESS"
                                ? "orange"
                                    : "brown"
                    }
                >
                    {item.status}
                </Label>
            </Table.Cell>

            <Table.Cell>
                <Dropdown icon="ellipsis vertical"  fluid  floating  pointing="bottom right">
                    <Dropdown.Menu>

                        <>
                        
                            {(item.status === "BOOKED" || item.status === "APPROVED") && item.checkedIn === false && (
                                <Dropdown.Item
                                    icon="trash"
                                    text="Cancel Booking"
                                    onClick={() => cancelBooking(item)}
                                />
                            )}
                        </>

                    </Dropdown.Menu>
                </Dropdown>
            </Table.Cell>

        </Table.Row>
    ));
    return (
        <div>

            {loading && (
                <Dimmer active inverted>
                    <Loader>fetching Bookings .......</Loader>
                </Dimmer>
            )}

            {pastBookings?.length > 0 && (
                <div>
                    <Table striped stackable compact="very" color="teal">
                        <Table.Header>
                            <Table.Row>
                             
                                <Table.HeaderCell style={{ color: '#26f09e' }}>S/N</Table.HeaderCell>
                               
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Image</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>BookingId</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Booked On</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Check In</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Check Out</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Room Type</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Amount</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Number of Nights</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}>Total</Table.HeaderCell>
                                <Table.HeaderCell style={{ color: '#26f09e' }}> Status</Table.HeaderCell>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>{bookings}</Table.Body>
                    </Table>
                </div>
            )}



        </div>
    )
}

export default PastBoookings